"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFullAddress = void 0;
// List of apartment-related keywords to remove from address2
const APARTMENT_KEYWORDS = [
    'apt',
    'apartment',
    'unit',
    '#',
    'suite',
    'bldg',
    'building',
    'app',
    'appartement',
    'unité',
    'bureau',
    'local',
];
/**
 * @example
 *
 * console.log(parseFullAddress('100-1234 Rue de la Paix', ''))
 * // { doorNumber: '1234', street: 'Rue de la Paix', apartmentNumber: '100' }
 *
 * console.log(parseFullAddress('456 Boulevard Saint-Laurent', '#302'))
 * // { doorNumber: '456', street: 'Boulevard Saint-Laurent', apartmentNumber: '302' }
 *
 * console.log(parseFullAddress('1010 Avenue des Champs-Élysées', 'Appartement 7B'))
 * // { doorNumber: '1010', street: 'Avenue des Champs-Élysées', apartmentNumber: '7B' }
 *
 * console.log(parseFullAddress('789 Rue du Faubourg', ''))
 * // { doorNumber: '789', street: 'Rue du Faubourg', apartmentNumber: '' }
 *
 * console.log(parseFullAddress("Avenue de l'Opéra", 'Bureau 205'))
 * // { doorNumber: '', street: "Avenue de l'Opéra", apartmentNumber: '205' }
 *
 * console.log(parseFullAddress('10', 'Rue Amanda-Olive #502'))
 * // { doorNumber: '10', street: 'Rue Amanda-Olive', apartmentNumber: '502' }
 */
function parseFullAddress(address1, address2) {
    let doorNumber = '';
    let street = '';
    let apartment = '';
    let addressLine1 = address1;
    let addressLine2 = address2;
    const apartmentRegex = new RegExp(`(${APARTMENT_KEYWORDS.join('|')})([^A-Za-z])`, 'gi');
    // If address1 has only numbers, assume the street name is in address2
    if (/^\d+$/.test(address1.trim())) {
        const concatenated = [address1, address2].map(a => (a || '').trim()).join(' ');
        const separator = '@@#_#@@';
        // Still split any possible apartment number
        const [line1, line2] = concatenated.replace(apartmentRegex, `${separator}$2`).split(separator);
        addressLine1 = line1;
        addressLine2 = line2;
    }
    // Check if address1 starts with "100-1234" format (apartment-door format)
    const aptDoorMatch = addressLine1.match(/^(\d+)-(\d+)\s+/);
    if (aptDoorMatch) {
        apartment = aptDoorMatch[1]; // Extract apartment number
        doorNumber = aptDoorMatch[2]; // Extract door number
        street = addressLine1.slice(aptDoorMatch[0].length).trim(); // Remove extracted part
    }
    else {
        // Standard format (door number at the start)
        const doorMatch = addressLine1.match(/^(\d+)\s+/);
        if (doorMatch) {
            doorNumber = doorMatch[1];
            street = addressLine1.slice(doorMatch[0].length).trim();
        }
        else {
            street = addressLine1.trim(); // If no door number, assume entire input is street
        }
    }
    // Clean up address2 by removing apartment keywords and leading #
    if (addressLine2) {
        apartment = addressLine2
            .replace(apartmentRegex, '$2')
            .replace(/[\.,]/g, '')
            .replace(/\b[A-Za-z]{2,}\b/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }
    return { doorNumber, street, apartment };
}
exports.parseFullAddress = parseFullAddress;
//# sourceMappingURL=person.js.map